import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_ROUTES } from '../../../contants/APP_ROUTES';
import { PARAMS } from '../../../contants/PARAMS';
import { QUERY_PARAMS } from '../../../contants/QUERY_PARAMS';
import { DateHelper } from '../../../helpers/DateHelper';
import { Helper } from '../../../helpers/Helper';
import { KeyValuePair } from '../../../models/common/keyValuePair';
import { PageOption } from '../../../models/common/pageOption';
import { Row } from '../../../models/tables/row';
import { TripPayment } from '../../../models/trips/trip.payment';
import { TripPaymentFilter } from '../../../models/trips/trip.payment.filter';
import { AlertService } from '../../../services/alert.service';
import { ParameterService } from '../../../services/parameter.service';
import { TripPaymentService } from '../../../services/trip-payment.service';
import { TripService } from '../../../services/trip.service';
import { ITripPickerChange } from '../../shared/ztsi-trip-picker/ztsi-trip-picker.component';
import { MatDialog } from '@angular/material';
import { TripPaymentDepositConfirmationDialogComponent } from '../trip-payment-deposit-confirmation-dialog/trip-payment-deposit-confirmation-dialog.component';

@Component({
  selector: 'app-trip-payment-list',
  templateUrl: './trip-payment-list.component.html',
  styleUrls: ['./trip-payment-list.component.css']
})
export class TripPaymentListComponent implements OnInit {
  	pageOption: PageOption<TripPaymentFilter> = new PageOption();
	rows: Row<TripPayment>[] = [];
	tripRates: KeyValuePair[] = [];

	constructor(
		private _tripPaymentService: TripPaymentService,
		private _alertService: AlertService,
		private _parameterService: ParameterService,
		private _tripService: TripService,
		private _router: Router,
		private _activatedRoute: ActivatedRoute,
		private _dialog: MatDialog
	) { }

	ngOnInit() {
		this.pageOption.searchFilter = new TripPaymentFilter();
		this.pageOption.searchFilter.checkDueDateTo = null;

		this._activatedRoute.queryParams.subscribe(
			params => {
				var filter = new TripPaymentFilter();
				if(params[QUERY_PARAMS.IS_DATE_NOW] != 'false'){
					filter.createdDate = DateHelper.getDateNowString();
				}

				if(params[QUERY_PARAMS.TRIP_ID] != undefined){
					filter.tripId = params[QUERY_PARAMS.TRIP_ID];
				}

				this._parameterService.getCachedParameter<number>(PARAMS.TRIP_PAYMENT_TABLE_DEFAULT_PAGE_SIZE, 3600).subscribe(
					value => {
						value = Number(value);
						this.pageOption.pageSize = isNaN(value) || value == 0 ? 50 : value;
						this.pageOption.pageNumber = 1;
		
						this.search(filter);
					}
				);

				this._tripService.getTripRates()
					.subscribe(value => {
						this.tripRates = value;
					});
			}
		);
	}

	fetchData(){
		this._tripPaymentService.search(this.pageOption).subscribe(
			result => {
				if (result.data != undefined) {
					if(this.pageOption.pageTotal <= 0){
						this.pageOption.pageTotal = result.totalPages;
					}

					let index = ((result.pageNumber - 1) * this.pageOption.pageSize);
					result.data.forEach(x => {
						let row = new Row<TripPayment>();
						row.status = 'loaded';
						row.object = x;
						this.rows[index] = row;
						index++;
					});
				}
			}
		);
	}

	onFetchNextData(pageNumber: number){
		this.pageOption.pageNumber = pageNumber;
		this.fetchData();
	}

	saveRow(index: number) {
		let expense = this.rows[index].object;
		if (expense.id == undefined || expense.id == 0) {
			this.createDailyTrip(index, expense);
		}
		else {
			this.updateDailyTrip(index, expense);
		}
	}

	addRow() {
		if(this.rows.filter(x => x.object.id == 0).length > 0){
			this._alertService.showWarning('Please save the new row before adding another row.');
			return;
		}

		let row = new Row<TripPayment>();
		row.status = 'new';
		row.object = new TripPayment();
		row.object.id = 0;		
		row.object.dateRecieved = DateHelper.getDateNowString();		

		this.rows.push(row);
	}

	removeRow(index: number){
		let id = this.rows[index].object.id;
		this.rows.splice(index, 1);

		//call delete
		if(id != 0){
			this._tripPaymentService.deleteTripPayment(id).subscribe(
				result => {
					if(result == undefined){
						this._alertService.showGenericError();
					}
					else if(result.errors.length > 0){
						this._alertService.displayErrorResult(result);
					}
				}
			);
		}
	}

	goToFormView(id: number){
		this._router.navigate([APP_ROUTES.tripPaymentForm.replace('/:id', ''), id]);
	}

	private createDailyTrip(index: number, newTripPayment: TripPayment) {
		this._tripPaymentService.addTripPayment(newTripPayment).subscribe(result => {
			if (result.object != undefined) {
				this.updateObject(index, result.object);
				this._alertService.showSuccess('Trip Payment information has been saved.')
			}
			else {
				this.rows[index].hasError = true;
				this._alertService.displayErrorResult(result.errorCollection);
			}
		});
	}

	private updateDailyTrip(index: number, existingTripPayment: TripPayment) {
		this._tripPaymentService.updateTripPayment(existingTripPayment).subscribe(result => {
			if (result.object != undefined) {
				this.updateObject(index, result.object);
				this._alertService.showSuccess('Trip Payment information has been updated.');
			}
			else {
				this.rows[index].hasError = true;
				this._alertService.displayErrorResult(result.errorCollection);
			}
		});
	}

	private updateObject(index: number, object: TripPayment){
		this.fetchData();
		// this.rows[index].object = object;
		// this.rows[index].hasError = false;	
	}

	search(filter: TripPaymentFilter) {
		if(filter != null){
			this.pageOption.searchFilter.dateRecieved = Helper.isNullOrUndefined(filter.dateRecieved) ? '' : filter.dateRecieved;
			this.pageOption.searchFilter.checkDueDateFrom = Helper.isNullOrUndefined(filter.checkDueDateFrom) ? '' : filter.checkDueDateFrom;
			this.pageOption.searchFilter.checkDueDateTo = Helper.isNullOrUndefined(filter.checkDueDateTo) ? '' : filter.checkDueDateTo;
			this.pageOption.searchFilter.createdDate = Helper.isNullOrUndefined(filter.createdDate) ? '' : filter.createdDate;
			this.pageOption.searchFilter.paymentType = Helper.isNullOrUndefined(filter.paymentType) ? '' : filter.paymentType;
			this.pageOption.searchFilter.remarks = Helper.isNullOrUndefined(filter.remarks) ? '' : filter.remarks;
            this.pageOption.searchFilter.tripId = filter.tripId;
            this.pageOption.searchFilter.clientId = filter.clientId;
		}

		this.rows = []; //reset array
		this.fetchData();
	}

	verify(index: number){
		this._dialog.closeAll();
		const dialogRef = this._dialog.open(TripPaymentDepositConfirmationDialogComponent, {
			width: "550px"
		});
	  
		dialogRef.afterClosed().subscribe((confirm: boolean) => {
			if (confirm) {				  
				this._tripPaymentService.verifyTripPayment(this.rows[index].object.id).subscribe(
					result => {
						if (result.object != undefined) {
							this.updateObject(index, result.object);
							this._alertService.showSuccess('Trip Payment information has been updated.');
						}
						else {
							this._alertService.displayErrorResult(result.errorCollection);
						}
					}
				)
			}
		});
	}

	getTripBalance(tripId: number): number{
		let index = this.tripRates.findIndex(x => x.key == tripId);
		return index > -1 ? this.tripRates[index].value : 0;
	}

	onTripChange(p: ITripPickerChange){	
		if(!p.tripid || p.trackingId == undefined || p.trackingId < 0){
			return;
		}

		const index = p.trackingId;
		this.rows[index].object.tripRate = this.getTripBalance(p.tripid);
		
		this._tripPaymentService.search({
			pageNumber: 1,
			pageSize: 100,
			pageTotal: 100,
			searchFilter: {
				tripId: this.rows[index].object.tripId
			}
		}).subscribe(result => {
			if (result.data != undefined) {
				let total = 0;
				result.data
					.filter(x => x.id != this.rows[index].object.id)
					.forEach(x => total += x.amount);

				this.rows[index].object.amountPaid = total;
				this.rows[index].object.remainingBalance = this.rows[index].object.tripRate - total;
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/trips/trip-payment-list/trip-payment-list.component.ts